import { isKeyOf } from '@/helpers';
import type { AllowedSettingsValues} from '@/login/composables/useSettings';
import { useSettings } from '@/login/composables/useSettings';
import { useLoginStore } from '@/login/stores/useLoginStore';
import ApiManagerBase from '@sysarb/sysarb-api/api/ApiManagerBase';

/**
 * @deprecated
 */
export class SystemSetting extends ApiManagerBase {
    protected managerName: string = 'systemsetting';

    /**
     * Gets the value of the requested field.
     * @param username The username of the current user
     */
    public async copySocialSecurityNumber(username: string): Promise<void> {
        const promise = super.postToServer<void>(true, this.managerName, 'copysocialsecuritynumber', { username });
        return promise;
    }

    /**
     * Gets the value of the requested field.
     * @param field The name of the field
     */
    public getFieldValue(field: string): any {
        if (field === 'DefaultLang') {
            const { selectedInstance } = useLoginStore();
            return selectedInstance?.DefaultLang;
        }

        const settings = useSettings().instanceSettings.value;

        if (settings == null) return null;

        if (!isKeyOf(settings, field)) {
            console.warn(`Field "${field}" does not exist in system settings.`);
            return null;
        }

        return settings[field];
    }

    /**
     * Sets bankID only for all users.
     */
    public async setBankIDOnly(): Promise<void> {
        const promise = super.postToServer<void>(true, this.managerName, 'setbankidonly');
        return promise;
    }

    /**
     * Updates the value of the requested field.
     * @param field The name of the field
     * @param value The value to be set
     */
    public async updateFieldValue(field: string, value: AllowedSettingsValues): Promise<void> {
        if (field === 'DefaultLang' && typeof value === 'string') {
            const { setInstanceLanguage } = useSettings();
            await setInstanceLanguage(value);
            return;
        }

        await useSettings().setInstanceSetting(field, value);
    }

    /**
     * Gets if the automated analysis function should be activated by default.
     */
    public getActivateAutomatedAnalyisByDefault(domain: string): boolean {
        const domains = new Set<string>(['spotify.sysarb.app']);
        return domains.has(domain);
    }
}
